import * as React from 'react';
const messageBarTransitionContext = React.createContext(undefined);
/**
 * @internal
 */
export const messageBarTransitionContextDefaultValue = {
  className: '',
  nodeRef: React.createRef()
};
/**
 * Context to pass nodeRef for animation to MessageBar components
 * @internal
 */
export const MessageBarTransitionContextProvider = messageBarTransitionContext.Provider;
/**
 * @internal
 */
export const useMessageBarTransitionContext = () => {
  var _React_useContext;
  return (_React_useContext = React.useContext(messageBarTransitionContext)) !== null && _React_useContext !== void 0 ? _React_useContext : messageBarTransitionContextDefaultValue;
};